// extracted by mini-css-extract-plugin
module.exports = {"featureList":"_FeatureList-styles-module--featureList--EHyq-","primaryButton":"_FeatureList-styles-module--primaryButton--Hn4_-","badge":"_FeatureList-styles-module--badge--QNepj"};